import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { NewsLinkModel } from '../../models/news-link.model';
import { NewsLinkAdapter } from '../../adapters/news-link.adapter';
import { ApiBaseService } from '../../../../core/services/api/api-base.service';

/**
 * Serviço para gerenciar links/notícias de conteúdo
 * Endpoint: /administration/content/links
 */
@Injectable({
  providedIn: 'root',
})
export class NewsLinkApiService extends ApiBaseService {
  constructor(http: HttpClient) {
    super(http);
  }

  /**
   * Buscar todos os links/notícias ativos
   * @returns Observable com array de links ordenados por data (mais recente primeiro)
   */
  getActiveLinks(): Observable<NewsLinkModel[]> {
    const url = `${this.apiBaseUrl}/administration/content/links`;

    return this.http
      .get<any>(url)
      .pipe(map((response) => NewsLinkAdapter.fromApiArray(response)));
  }
}
